import { render, staticRenderFns } from "./PxIconComponent.vue?vue&type=template&id=04703692&scoped=true&"
import script from "./PxIconComponent.vue?vue&type=script&lang=js&"
export * from "./PxIconComponent.vue?vue&type=script&lang=js&"
import style0 from "./PxIconComponent.vue?vue&type=style&index=0&id=04703692&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04703692",
  null
  
)

export default component.exports